<template>
  <v-card
    variant="outlined"
    height="200"
    width="320"
    style="border-color: #ccc">
    <v-card-text class="h-100">
      <div class="d-flex flex-column justify-space-between h-100 ga-2">
        <slot name="default"></slot>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
export default {
  name: 'PrintedFormCard',
}
</script>

<style scoped lang="scss"></style>
